import "core-js/modules/es.string.link.js";
export default {
  data: function data() {
    return {};
  },
  render: function render() {
    var h = arguments[0];
    var link = this.$route.meta.link;
    if ({
      link: link
    }.link === '') {
      return '404';
    }
    var url = {
      link: link
    }.link;
    var height = document.documentElement.clientHeight - 94.5 + 'px';
    var style = {
      height: height
    };
    return h("div", {
      "style": style
    }, [h("iframe", {
      "attrs": {
        "src": url,
        "frameborder": 'no',
        "scrolling": 'auto'
      },
      "style": 'width: 100%; height: 100%'
    })]);
  }
};